<template>
  <q-dialog v-model="feedbackFormDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm" style="width: 150ex; margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: auto; border-radius: 10px;">
        <q-card style="padding: 50px; border-radius: 10px;" class="q-pa-md">
          <div v-if="!disableUserFunctionality" align="right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin: -70px -40px 0px 0px;" /></div>
          <div class="dialogText">Feedback / Request Access</div>
          <div v-if="disableUserFunctionality">Unauthorized Access: All features will be disabled until access is provided to your account.</div>

          <br />

          <q-form
            @submit="sendFeedback"
            class="q-gutter-md"
          >
            <div v-if="!disableUserFunctionality" class="q-pa-md">
              <div class="q-gutter-md row items-center justify-center">
                <q-select
                  filled
                  v-model="feedbackType"
                  use-input
                  label="Type"
                  style="width: 250px"
                  :options="feedbackTypeOptions"
                  @filter="filterFeedbackOptions"
                />
              </div>
            </div>

            <div style="display: flex; alignItems: baseline">
              <div>Message</div>
              <q-space />
              <q-input
                v-model="message"
                outlined
                lazy-rules
                :rules="[(val) => (val && val.length > 0) || 'Required ']"
                type="textarea"
                style="width: 75%;"
              />
            </div>

            <div v-show="false && feedbackType === 'Request Access'" style="display: flex; alignItems: baseline">
              <div>Access Level</div>
              <q-space />
              <span style="width: 75%;">
                <q-checkbox v-model="accessLevel" val="API" label="API" :disable="currentUserAccessLevel.includes('API')" />
                <q-checkbox v-model="accessLevel" val="Admin" label="Admin" :disable="currentUserAccessLevel.includes('Admin')" />
                <q-checkbox v-model="accessLevel" val="Delete" label="Delete Documents" :disable="currentUserAccessLevel.includes('Delete')" />
                <q-checkbox v-model="accessLevel" val="Edit" label="Edit Documents" :disable="currentUserAccessLevel.includes('Edit')" />
                <q-checkbox v-model="accessLevel" val="Upload" label="Upload Documents" :disable="currentUserAccessLevel.includes('Upload')" />
              </span>
            </div>

            <div v-show="feedbackType === 'Request Access'" style="display: flex; alignItems: baseline">
              <div>Scopes Access</div>
              <q-space />
              <span style="width: 75%;">
                <q-checkbox v-model="scopesAccess" val="Factrak" label="Factrak" :disable="currentUserScopesAccess.includes('Factrak')" />
                <q-checkbox v-model="scopesAccess" val="Fire Safety" label="Fire Safety" :disable="currentUserScopesAccess.includes('Fire Safety')" />
                <q-checkbox v-model="scopesAccess" val="HIDOE Drawings" label="HIDOE Drawings" :disable="currentUserScopesAccess.includes('HIDOE Drawings')" />
                <q-checkbox v-model="scopesAccess" val="HIDOE Drawings Light" label="HIDOE Drawings Light" :disable="currentUserScopesAccess.includes('HIDOE Drawings Light')" />
                <q-checkbox v-model="scopesAccess" val="Maui Fire Claims 2023" label="Maui Fire Claims 2023" :disable="currentUserScopesAccess.includes('Maui Fire Claims 2023')" />
              </span>
            </div>

            <div v-show="feedbackType === 'Request Access'" style="display: flex; alignItems: baseline">
              <div>User Groups</div>
              <q-space />
              <q-select
                outlined
                v-model="userGroups"
                use-input
                use-chips
                multiple
                input-debounce="0"
                :options="userGroupsOptions"
                @filter="filterUserGroups"
                style="width: 75%;"
              />
            </div>

            <br />

            <div style="display: flex; alignItems: baseline">
              <q-space />
              <q-btn
                label="Send Feedback / Request Access"
                type="submit"
                color="primary"
                no-caps
              />
              <q-btn
                label="Cancel"
                color="cancelButton"
                class="q-ml-sm"
                no-caps
                v-if="!disableUserFunctionality"
                v-close-popup
              />
              <q-space />
            </div>
          </q-form>
        </q-card>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import { ref, onMounted } from "vue";
import AuthHelper from "../helper/AuthHelper.js";
import CommonHelper from "../helper/CommonHelper.js";
import NotificationHelper from "../helper/NotificationHelper";
import EmailService from "../service/EmailService.js";
import axios from "axios";

export default {
  name: "FeedbackForm",
  props: {
    disableUserFunctionality: Boolean
  },
  setup(props) {
    const feedbackFormDialog =  ref(false);
    const message =  ref();
    const accessLevel = ref([]);
    const scopesAccess = ref([]);
    const userGroups = ref([]);

    function displayFeedbackForm() {
      feedbackFormDialog.value = true;
    }

    const currentUserUID = ref();
    const email = ref();
    const currentUserAccessLevel = ref([]);
    const currentUserScopesAccess = ref([]);
    const currentUserGroups = ref([]);

    const userGroupsOptionsArray = ref([]);
    const userGroupsOptions = ref([]);

    /*
     * Filter function for the User Groups dropdown
     */
    function filterUserGroups(val, update) {
      CommonHelper.filterOptions(val, update, userGroupsOptions, userGroupsOptionsArray.value);
    }

    onMounted(() => {
      getCurrentValues();
    });

    async function getCurrentValues() {
      const userData = await AuthHelper.getCurrentUserData(true, true);
      currentUserUID.value = userData.uid;
      email.value = userData.email;
      currentUserAccessLevel.value = userData.accessLevel;
      currentUserScopesAccess.value = userData.scopesAccess;
      accessLevel.value = currentUserAccessLevel.value;
      scopesAccess.value = currentUserScopesAccess.value;
      getUserGroups();
    }

    async function getUserGroups() {
      try {
        const response = await CommonHelper.getUserGroups(false);

        response.forEach((userGroup) => {
          userGroupsOptionsArray.value.push(userGroup.name);

          if (userGroup.emails !== "" && userGroup.emails.split(",").includes(email.value)) {
            currentUserGroups.value.push(userGroup.name);
          }
        })

        userGroups.value = currentUserGroups.value;
      } catch (error) {
        EmailService.sendErrorEmail("FeedbackForm.vue - getUserGroups", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }

    const feedbackType = ref('Request Access');
    const feedbackTypeOptionsArray = [
      "Request Access",
      "New Feature",
      "Improve Feature",
      "Bug Report",
      "Other",
    ];
    const feedbackTypeOptions = ref(feedbackTypeOptionsArray);

    /*
    * Filter function for the Feedback dropdown
    */
    function filterFeedbackOptions(val, update) {
        CommonHelper.filterOptions(val, update, feedbackTypeOptions, feedbackTypeOptionsArray);
    }

    async function sendFeedback() {
      try {
        const accessLevelChanges = arrayChanges(currentUserAccessLevel.value, accessLevel.value);
        const scopesAccessChanges = arrayChanges(currentUserScopesAccess.value, scopesAccess.value);
        const userGroupsChanges = arrayChanges(currentUserGroups.value, userGroups.value);

        axios.get(
          `${process.env.VUE_APP_API_GATEWAY}sendFeedback?currentUserUID=${currentUserUID.value}&type=${feedbackType.value}&message=${encodeURIComponent(message.value)}&accessLevel=${accessLevelChanges}&scopesAccess=${scopesAccessChanges}&userGroups=${encodeURIComponent(userGroupsChanges)}&key=${process.env.VUE_APP_API_KEY}`
        );

        if (!props.disableUserFunctionality) {
          feedbackFormDialog.value = false;
        }

        NotificationHelper.createSuccessNotification("Feedback / Request Access Sent");
      } catch (error) {
        EmailService.sendErrorEmail("FeedbackForm.vue - sendFeedback", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }

    function arrayChanges(currentArray, newArray) {
      let returnValue = [];

      newArray.forEach((value) => {
        if (!currentArray.includes(value)) {
          returnValue.push(value);
        }
      })

      return returnValue;
    }

    return {
      //variable properties
      feedbackFormDialog,
      message,
      accessLevel,
      scopesAccess,
      userGroups,
      currentUserAccessLevel,
      currentUserScopesAccess,
      userGroupsOptions,
      feedbackType,
      feedbackTypeOptions,

      //functions
      displayFeedbackForm,
      filterUserGroups,
      filterFeedbackOptions,
      sendFeedback
    };
  },
};
</script>